export const STORAGE_KEYS = {
  AUTH_TOKEN: 'sorti-token',
  AUTH_REFRESH_TOKEN: 'sorti-refresh-token',
  AUTH_USER: 'sorti-user',
  TUTORIAL_COMPLETED: 'sorti-tutorial-completed',
  TUTORIAL_ASKED: 'sorti-tutorial-asked',
} as const;
